import { MainBlock } from '@blocks/BlockMain/model'

import { PagesPath, pagesTitles } from './pages-titles'

export const mainBlock: MainBlock = {
	title: pagesTitles[PagesPath.vseBudetHorosho].mainBlockTitle,
	textItems: [
		'Объединим все кредиты',
		'Снизим платёж',
		'Без кредитной истории и справок о доходах',
	],
	buttonText: 'Оставить заявку',
	footnote: 'Владимир Холодилов, руководитель отдела по работе с клиентами',
	faceImageName: {
		mobile: 'KV-loans-business-mob.png',
		default: 'keyvisual-loans-business.png',
	},
	imageAlt: 'Владимир Холодилов, руководитель отдела по работе с клиентами',
}
